export default "__VITE_ASSET__D66J_ll___"